import React from 'react';
import { Field, useFormikContext } from 'formik';
import { Box, Grid } from '@mui/material';

import { InputUI, FormErrorUI, FormLabelUI, SelectUI } from '../Interface';
import { MaterialPlanStatusList } from '../../config/materialPlan';

const MaterialPlanFields = ({ viewField }) => {
  const { values, errors } = useFormikContext();

  return (
    <Box sx={{ px: 2, mb: 5, width: '100%', overflowX: 'hidden' }}>
      <Grid container spacing={2} sx={{ width: '100%', m: 0 }}>
        <Grid item xs={12} md={3} sx={{ pl: '0 !important' }}>
          <Field
            type="text"
            name="planNo"
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Tervszám" />}
            helperText={<FormErrorUI message={errors.planNo} />}
            variant="standard"
            disabled={true}
            InputLabelProps={{ shrink: values.planNo !== '' }}
          />
        </Grid>

        <Grid item xs={12} md={9}>
          <Field
            type="text"
            name="description"
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Leírás" />}
            helperText={<FormErrorUI message={errors.description} />}
            variant="standard"
            disabled={viewField}
            InputLabelProps={{ shrink: values.description !== '' }}
          />
        </Grid>

        <Grid item xs={12} md={3} sx={{ pl: '0 !important' }}>
          <Field
            name="status"
            component={SelectUI}
            fullWidth
            label={<FormLabelUI text="Státusz" />}
            helperText={<FormErrorUI message={errors.status} />}
            variant="standard"
            disabled
            value={values.status ?? ''}
            option={MaterialPlanStatusList}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MaterialPlanFields;
